<div class="fixed inset-0 flex items-center justify-center bg-jamaica-green-600 z-50">
  <div class="text-center">
    <img src="/logos/wsy-yardBull-Icon.png" alt="Wall St. Yardie Logo" 
         class="h-16 w-16 mx-auto mb-4 animate-pulse" />
    <div class="text-white text-xl font-semibold">{{ statusMessage }}</div>
    <div class="text-white/70 text-sm mt-2">Please wait...</div>
  </div>
</div>
